import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: "https://keycloak.hailsolve.net:8443",
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export default keycloak;